import {
  agroforestryProjectAllocations,
  cheapAgroforestryProjectAllocations,
  landscapeRestorationProjectAllocations,
  UKReforestationProject,
} from '../tree-projects';
import { ImpactFund } from '../types/projects';
import { PEATLANDS_PROJECT_ID, SEAGRASS_PROJECT_ID, WILDFLOWERS_PROJECT_ID } from '../habitat-restoration';
import { UK_CLIMATE_AND_NATURE_FUND_TITLE } from '../impact-shop/constants';

export const builtInTreeMixes = {
  AGROFORESTRY: {
    title: 'Agroforestry mix',
    allocations: agroforestryProjectAllocations,
  },
  CHEAP_AGROFORESTRY: {
    title: 'Cheap agroforestry mix',
    allocations: cheapAgroforestryProjectAllocations,
  },
  LANDSCAPE_RESTORATION: {
    title: 'Landscape restoration mix',
    allocations: landscapeRestorationProjectAllocations,
  },
} as const;

export type BuiltInTreeMixCode = keyof typeof builtInTreeMixes;

export type BuiltInImpactFundAllocation =
  | { type: 'PROJECT'; projectId: number; proportion: number }
  | { type: 'TREE_MIX'; treeMix: BuiltInTreeMixCode; proportion: number };

export type BuiltInImpactFundDefinition = {
  title: string;
  allocations: BuiltInImpactFundAllocation[];
};

export const builtInImpactFunds: Record<ImpactFund, BuiltInImpactFundDefinition> = {
  [ImpactFund.UK_CLIMATE_NATURE_FUND]: {
    title: UK_CLIMATE_AND_NATURE_FUND_TITLE,
    allocations: [
      { type: 'PROJECT', projectId: UKReforestationProject.projectId, proportion: 0.6 },
      { type: 'PROJECT', projectId: PEATLANDS_PROJECT_ID, proportion: 0.15 },
      { type: 'PROJECT', projectId: WILDFLOWERS_PROJECT_ID, proportion: 0.15 },
      { type: 'PROJECT', projectId: SEAGRASS_PROJECT_ID, proportion: 0.1 },
    ],
  },
  [ImpactFund.FORESTS_LANDSCAPES_FUND]: {
    title: 'Forests & Landscapes Fund',
    allocations: [
      { type: 'TREE_MIX', treeMix: 'AGROFORESTRY', proportion: 0.9 },
      { type: 'PROJECT', projectId: UKReforestationProject.projectId, proportion: 0.1 },
    ],
  },
  [ImpactFund.BAFTA_FUND]: {
    title: 'We are Albert — Creative Offsets',
    allocations: [
      { type: 'PROJECT', projectId: 7067, proportion: 0.5 },
      { type: 'PROJECT', projectId: 10892, proportion: 0.5 },
    ],
  },
  [ImpactFund.FLIGHTS_OFFSET_FUND]: {
    title: 'Flight emissions offset',
    allocations: [
      { type: 'PROJECT', projectId: 7067, proportion: 0.5 },
      { type: 'PROJECT', projectId: 10892, proportion: 0.35 },
      { type: 'PROJECT', projectId: 8843, proportion: 0.15 },
    ],
  },
};
